import React, { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';

// In-App Notification Toast Component
const InAppNotification = ({ notification, onClose }) => {
  useEffect(() => {
    // Auto-close after 10 seconds
    const timer = setTimeout(() => {
      onClose();
    }, 10000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className="fixed top-20 right-4 z-[9999] animate-slideIn"
      style={{
        animation: 'slideInRight 0.3s ease-out',
      }}
      data-testid={`in-app-notification-${notification.id}`}
    >
      <div className="bg-black text-white rounded-lg shadow-2xl p-4 max-w-sm border border-white/30 backdrop-blur-xl" data-testid="in-app-notification-card">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
            <Bell className="w-5 h-5" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-sm mb-1" data-testid="in-app-notification-title">{notification.title}</h3>
            <p className="text-sm text-white/90 break-words" data-testid="in-app-notification-body">{notification.body}</p>
            <p className="text-xs text-white/70 mt-1" data-testid="in-app-notification-timestamp">
              {new Date(notification.timestamp).toLocaleTimeString('el-GR')}
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-white/70 hover:text-white flex-shrink-0"
            data-testid="in-app-notification-close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default InAppNotification;
